

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { ApiService } from '../core/api.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { loadingService } from '../loading.service';
import { DebugContext } from '@angular/core/src/view';

@Injectable()
export class CommerceService {

  wizard = {
    id: 0,
    step: 1,
  }
  
  info: any = {};

  wizardDB = new BehaviorSubject<any>({});
  disket = new Subject<any>();
  titulo = new Subject<any>();
  page1: any = {};
  page2: any = {};
  page3: any = {};
  savePage: boolean = false;

  data = { id:0 , step: 0 };

  dataSub = new Subject<any>();

  constructor(
    private store: Store<AppState>,
    private apiService: ApiService,
    private toast: ToastrService,
    private loadingService: loadingService,
  ) { }

  saveWizardDBData(data: any){
    this.wizardDB.next(data);
  }


  save(payload) {
    this.loadingService.showLoading()
    return this.apiService.send('commerce/save', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }
  saveFase1(payload){
    this.loadingService.showLoading();
    return this.apiService.send('commerce/SaveRegisterF1', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  saveFase2(payload){
    this.loadingService.showLoading();
    return this.apiService.send('commerce/SaveRegisterF2', payload)
      .then(result => {
        this.loadingService.closeLoading();        
        return result;
      })
  }

  saveFase3(payload){
    this.loadingService.showLoading();
    return this.apiService.send('commerce/SaveRegisterF3', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }



  getAllFiles(tipoPersona: number, enRegistro: boolean) {
    return this.apiService.send('commerce/GetAllFiles', {tipoPersona: tipoPersona, enRegistro: enRegistro })
      .then(result => {
        return result;
      })
  }
  saveAll(payload) {
    this.loadingService.showLoading();
    return this.apiService.send('commerce/saveall', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  getWizard(userID) {
    this.loadingService.showLoading();
    return this.apiService.send('commerce/getInfo', { userId: userID })
      .then(result =>
      {
        if(result != undefined && result != null)
        {
          this.info = result;
          this.data = result;
        }
        this.loadingService.closeLoading();
        return result;
      })
  }

  saveWizard(payload) {
    //console.log('payload:', payload);
    this.data = payload;
    this.dataSub.next(this.data);
  }

  saveFacebook(payload) {
    this.data['facebook'] = payload;
  }
  saveWizardFile(payload) {
    this.data['files'] = payload;
  }
  saveWizardData() {
    this.loadingService.showLoading();
    if(this.data.id == 0)
    {
      this.data.id = this.wizard.id;
    }
    this.data.step = this.wizard.step;

    return this.apiService.send('commerce/saveWizard', this.data)
      .then(result => {
        this.loadingService.closeLoading();
        if(result != null && result != undefined)
        {
          this.data = result;
          this.toast.success('Datos Salvados con Exito.', 'Exito')
        }
        else
        {
          this.toast.error('Error al Salvar los Datos.', 'Error')
        }        
        return result;
      })
      .catch(error => {
        this.loadingService.closeLoading();
        this.toast.error('Error al Salvar los Datos.', 'Error');
      });
  }
  getFile(payload) {
    //this.loadingService.showLoading();
    return this.apiService.send('file/getbyid', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  getFiles(payload) {
    return this.apiService.send('file/getbygroup', payload)
      .then(result => {
        
        if(result != undefined)
        {
          return result;
        }
        else
        {
          return null;
        }
        
      });
      
  }

  getFileBilling(payload) {
    //this.loadingService.showLoading();
    return this.apiService.send('file/getFileBilling', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  saveSlider(payload) {
    return this.apiService.send('commerce/saveslider', payload)
      .then(result => {
        return result;
      })
  }

  DeleteFile(payload)
  {
    return this.apiService.send('file/DeleteFileUser', payload)
    .then(result => {
      return result;
    })
  }

  SaveTmpOffer(payload)
  {
    return this.apiService.send('commerce/SaveTmpOffer', payload)
    .then(result => {
      return result;
    })
  }

  addNewTpv(payload) {
    this.loadingService.showLoading();
    return this.apiService.send('finance/addTpv', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  getData() {
    return this.data;
  }

  setPage1(page: any) {
    this.page1 = page;
  }
  setPage2(page: any) {
    this.page2 = page;
  }
  setPage3(page: any) {
    this.page3 = page;
  }

  setTitulo(titulo){
    this.titulo.next(titulo);
  }

  validateSatWs(payload)
  {
    this.loadingService.showLoading();
    return this.apiService.sendSat('Sat/RegisterCredential', payload, "post")
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  checkSatWs(payload)
  {
    return this.apiService.sendSat('Sat/getEstatusSatWs', payload, "post")
      .then(result => {
        return result;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/app/commerce.service.ts